/**
 * sl-4wjh.2.3: Web Search feature tab.
 * Thin wrapper around CapabilityFeatureTab for capability='websearch'.
 */
import type { AnalyticsPeriodRange, ContextType } from '../types';
import { CapabilityFeatureTab } from './capability-feature-tab';

export interface WebsearchTabProps {
  workspaceId: string;
  period: string | AnalyticsPeriodRange;
  context: ContextType;
}

export const WebsearchTab = (props: WebsearchTabProps) => (
  <CapabilityFeatureTab
    {...props}
    capability="websearch"
    cacheKey="websearch"
    countCardKey="searches"
    countCardDefault="Searches"
  />
);
